import account_icon_select from '@/assets/home/dataEffect/account_icon_select.png'
import account_icon_unselect from '@/assets/home/dataEffect/account_icon_unselect.png'

export const userRoleDict = {
	admin: 1,
	operate: 2,
	data: 3
}

export const getTabList = () => {
	return [
		{
			name: '',
			router: '/dataEffect',
			children: [
				{
					name: '数据报表',
					icon: account_icon_unselect,
					activeIcon: account_icon_select,
					router: "/dataEffect/dataReport"
				}
			]
		}
	]
}


export const sortDict = {
	ascending: 'asc',
	descending: 'desc',
	asc: 'ascending',
	desc: 'descending'
}


export const totalToColMap = [
	{
		to: 'orderNum',
		from: 'customerOrderNum'
	},
	{
		to: 'orderReturnNum',
		from: 'customerOrderReturnNum'
	},
	{
		to: 'orderReturnTotalPrice',
		from: 'customerOrderReturnTotalPrice'
	},
	{
		to: 'orderValidEstimateCosPrice',
		from: 'customerOrderValidEstimateCosPrice'
	},
	{
		to: 'orderValidNum',
		from: 'customerOrderValidNum'
	},
	//
	{
		to: 'totalSaleRoi',
		from: 'customerTotalSaleRoi'
	},
	{
		to: 'roi',
		from: 'customerRoi'
	},
	{
		to: 'orderValidTotalSalePrice',
		from: 'customerOrderValidTotalSalePrice'
	}
]



// WEBPACK FOOTER //
// ./src/pages/home/config.js